/**
 * 存放公用选择器 业务数据自行维护selectorItem
 */
export default {};
